// log
export const SET_LOG_LIST = 'SET_LOG_LIST'
export const SET_LOG_PAGE_TOTAL = 'SET_LOG_PAGE_TOTAL'
export const SET_LOG_QUERY = 'SET_LOG_QUERY'
export const SET_LOG_PAGE_SIZE = 'SET_LOG_PAGE_SIZE'
export const SET_LOG_PAGE_NUM = 'SET_LOG_PAGE_NUM'
export const SET_LOG_SEARCHING = 'SET_LOG_SEARCHING'
export const RESET_LOG_LIST = 'RESET_LOG_LIST'
// statistics
// export const SET_STATISTICS_LIST = 'SET_STATISTICS_LIST'
export const SET_STATISTICS_SEARCHING = 'SET_STATISTSET_STATISTICS_SEARCHINGICS_PAGE_NUM'

// shareLinkStatistics

export const SET_SHARE_LINK_STATISTICS_SEARCHING = 'SET_SHARE_LINK_STATISTICS_SEARCHING'

// cardframemonitor

export const SET_CARD_FRAME_SEARCHING = 'SET_CARD_FRAME_SEARCHING'
export const SET_ABNORMAL_JOB_LIST = 'SET_ABNORMAL_JOB_LIST'
export const SET_CARD_FRAME_SORT = 'SET_CARD_FRAME_SORT'
export const SET_CARD_FRAME_QUERY = 'SET_CARD_FRAME_QUERY'
export const SET_CARD_FRAME_LIST_PAGE_SIZE = 'SET_CARD_FRAME_LIST_PAGE_SIZE'
export const SET_FRAME_PAGE_NUM = 'SET_FRAME_PAGE_NUM'
export const SET_LIST_PAGE_TOTAL = 'SET_LIST_PAGE_TOTAL'

// messageMonitoring
export const SET_MONITOR_TASK_LIST = 'SET_MONITOR_TASK_LIST'
export const SET_SUBSCRIBE_CONTROL_LIST = 'SET_SUBSCRIBE_CONTROL_LIST'
export const SET_MONITOR_TASK_LIST_PAGE_NUM = 'SET_MONITOR_TASK_LIST_PAGE_NUM'
export const SET_MONITOR_TASK_LIST_PAGE_SIZE = 'SET_MONITOR_TASK_LIST_PAGE_SIZE'
export const SET_MONITOR_TABLE_LOADING = 'SET_MONITOR_TABLE_LOADING'

// statisticsCardFrame
export const SET_STATISTICS_FRAME_LIST = 'SET_STATISTICS_FRAME_LIST'
export const SET_STATISTICS_FRAME_SORT = 'SET_STATISTICS_FRAME_SORT'
export const SET_STATISTICS_FRAME_QUERY = 'SET_STATISTICS_FRAME_QUERY'
export const SET_STATISTICS_FRAME_LIST_PAGE_SIZE = 'SET_STATISTICS_FRAME_LIST_PAGE_SIZE'
export const SET_STATISTICS_FRAME_PAGE_NUM = 'SET_STATISTICS_FRAME_PAGE_NUM'
export const SET_STATISTICS_LIST_PAGE_TOTAL = 'SET_STATISTICS_LIST_PAGE_TOTAL'

// stuckFrameStatistics
export const SET_STUCK_FRAME_STATISTICS_LIST = 'SET_STUCK_FRAME_STATISTICS_LIST'
export const SET_STUCK_FRAME_STATISTICS_SORT = 'SET_STUCK_FRAME_STATISTICS_SORT'
export const SET_STUCK_FRAME_STATISTICS_QUERY = 'SET_STUCK_FRAME_STATISTICS_QUERY'

// channelClassification
export const SET_CHANNEL_LIST = 'SET_CHANNEL_LIST'
export const SET_CHANNEL_LIST_PAGE_SIZE = 'SET_CHANNEL_LIST_PAGE_SIZE'
export const SET_CHANNEL_PAGE_NUM = 'SET_CHANNEL_PAGE_NUM'
export const SET_CHANNEL_LIST_PAGE_TOTAL = 'SET_CHANNEL_LIST_PAGE_TOTAL'
export const SET_CHANNEL_LIST_QUERY = 'SET_CHANNEL_LIST_QUERY'
export const SET_CHANNEL_LIST_SEARCHING = 'SET_CHANNEL_LIST_SEARCHING'
export const SET_NATURAL_LIST = 'SET_NATURAL_LIST'
export const SET_NATURAL_PAGE_TOTAL = 'SET_NATURAL_PAGE_TOTAL'
export const SET_NATURAL_QUERY = 'SET_NATURAL_QUERY'
export const SET_NATURAL_PAGE_SIZE = 'SET_NATURAL_PAGE_SIZE'
export const SET_NATURAL_PAGE_NUM = 'SET_NATURAL_PAGE_NUM'
export const SET_NATURAL_SEARCHING = 'SET_NATURAL_SEARCHING'

// cardFrameDetails
export const SET_CARD_FRAME_DETAILS_SEARCHING = 'SET_CARD_FRAME_DETAILS_SEARCHING'
export const SET_CARD_FRAME_DETAILS_LIST = 'SET_CARD_FRAME_DETAILS_LIST'
export const SET_CARD_FRAME_DETAILS_SORT = 'SET_CARD_FRAME_DETAILS_SORT'
export const SET_CARD_FRAME_DETAILS_QUERY = 'SET_CARD_FRAME_DETAILS_QUERY'
export const SET_CARD_FRAME_DETAILS_LIST_PAGE_SIZE = 'SET_CARD_FRAME_DETAILS_LIST_PAGE_SIZE'
export const SET_CARD_FRAME_DETAILS_PAGE_NUM = 'SET_CARD_FRAME_DETAILS_PAGE_NUM'
export const SET_CARD_FRAME_DETAILS_LIST_PAGE_TOTAL = 'SET_CARD_FRAME_DETAILS_LIST_PAGE_TOTAL'
